
import { useParams } from "react-router-dom";
import TradingPanel from "@/components/coin-detail/TradingPanel";
import CommentsSection from "@/components/coin-detail/CommentsSection";
import StakingPanel from "@/components/coin-detail/StakingPanel";
import ReputationCard from "@/components/coin-detail/ReputationCard";
import LaunchPanel from "@/components/coin-detail/LaunchPanel";
import Header from "@/components/Header";
import HolderDistribution from "@/components/coin-detail/HolderDistribution";
import TradingViewWidget from "@/components/TradingViewWidget";
import { useCoins, fallbackCoins } from "@/hooks/useCoins";

const MOCK_TOKEN_ADDRESS = "0x1234567890123456789012345678901234567890";
const MOCK_CREATOR_ADDRESS = "0x1234567890123456789012345678901234567890";

const CoinDetail = () => {
  const { coinId } = useParams();
  const { data: coinsData } = useCoins(100);

  if (!coinId) return null;

  const coin = (coinsData?.coins || fallbackCoins).find((item) => item.id.toLowerCase() === coinId.toLowerCase() || item.legacyId?.toLowerCase() === coinId.toLowerCase() || item.name.toLowerCase().replace(/\s+/g, "-") === coinId.toLowerCase());
  const tokenAddress = coin?.coinAddress || (/^0x[a-fA-F0-9]{40}$/.test(coinId) ? coinId : MOCK_TOKEN_ADDRESS);
  const creatorAddress = coin?.creator?.startsWith("0x") ? coin.creator : MOCK_CREATOR_ADDRESS;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-8">
            <div className="h-[500px] w-full rounded-lg overflow-hidden bg-card">
              <TradingViewWidget symbol={coin?.ticker || coinId} />
            </div>
            <LaunchPanel 
              tokenAddress={tokenAddress}
            />
            <TradingPanel coinId={coinId} tokenAddress={tokenAddress} />
            <CommentsSection coinId={coinId} />
          </div>
          <div className="space-y-8">
            <ReputationCard creatorAddress={creatorAddress} />
            <StakingPanel coinId={coinId} />
            <HolderDistribution tokenAddress={tokenAddress} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default CoinDetail;
